const cellStyle = {
  color: 'white',
  fontWeight: 'bold',
  textAlign: 'left',
};
export default cellStyle;
